// extracted by mini-css-extract-plugin
module.exports = {"assignInfo":"_2hAz-aMPAn1NwfSnRX--","editBtn":"_1B9cGnvkJUGqT56WeupUL6","icon":"_1rNjiRMk_pjEt3APrESjxU"};